import {
    TAG_CLOUD,
    PROJECT_LISTING,
    PROJECT_LISTING_NEW,
    UPDATE_TAG_ID
} from './Types';
import axios from "axios/index";
import {API_URL} from "../config/config";
import {getAuthToken, getAuthUserDetails, setVideoDetailLocalStorage} from "./Common";
import { stripHtml, truncateText } from "../utils";
import { TAG_COUNT, TAG_TITLE_COUNT } from "../config/config";

/**
 * Get profile details from local storage
 * @returns {function(*)}
 */
export function getTagCloudDetails(count = '', userId = '', authToken = '', callback) {
    let authTokenParam = '';
    let userIdParam = '';

    /* set default user user detail if param are empty */
    if( userId == '' && authToken == '' ){
      authTokenParam = getAuthToken();
      let userDetails = getAuthUserDetails();
      userIdParam = userDetails.userId;
    }else{
      authTokenParam = authToken;
      userIdParam = userId;
    }

    return (dispatch) => {
      axios.get(`${API_URL}deck/clouds/${userIdParam}`, {
          headers: {Authorization: `Bearer ${authTokenParam}`}
      }).then((response) => {
          callback(response);
        dispatch({
            type    : TAG_CLOUD,
            payload : response.data[0].tagCounts
        });
      }).catch(function (error) {
        callback(error.response);
    });
  }
}

/**
 * save video clicks data
 * @param data
 * @returns {function(*)}
 */
export function saveVideoClickData(data, callback) {
  let postData = {timestamps: data.clickedTimeList}
  const authToken = getAuthToken();
  const userDetails = getAuthUserDetails();
  const request = axios.post(`${API_URL}deck/cloud/${userDetails.userId}/${data.videoId}`, postData, {
    headers: {Authorization: `Bearer ${authToken}`}
  });
  return (dispatch)=> {
      request.then((data) => {
        setVideoDetailLocalStorage('');
            callback(data);
            return true;
      })
      .catch(function (error) {
        setVideoDetailLocalStorage('');
          callback(error.response);
      });
  }
}

/**
 * Get profile details from local storage
 * @returns {function(*)}
 */
export function projectListingGrid(tagId, pageCounter = 1, isClearList = false, callback) {
    const authToken = getAuthToken();
    const userId = getAuthUserDetails();
    const actionType = (isClearList)?PROJECT_LISTING_NEW:PROJECT_LISTING;

    return (dispatch) => {
      axios.get(`${API_URL}deck/stories/${tagId}?page=${pageCounter}`, {
          headers: {Authorization: `Bearer ${authToken}`}
      }).then((response) => {
        callback(response);

        /* Code for applying ellipses for tags */
        let count = 0;
        let tagsArr=[];
        let tagTitleCount = 0;
        let tagTitleArr=[];
        response.data.map((tagDetail, index)=>{
          count = 0;
          tagsArr=[];
          tagTitleCount = 0;
          tagTitleArr=[];
          tagDetail.tags.map((tag, index)=>{
            count = count + tag.tagName.length;
            if(count <= TAG_COUNT) {
              tag.isTagMore = 0;
              tagsArr.push(tag);
            }
          })
          if(count >= TAG_COUNT) {
            tagsArr.map((tag, index)=>{
                tagsArr[tagsArr.length-1]['isTagMore'] = 1
            })
          }
          tagDetail.tags= tagsArr;

          /* Code for applying ellipses for tag titles */
          let tagTitleString = tagDetail.title;
          let tagTitleArray = tagTitleString.split(" ");
          tagTitleArray.map((title, index) => {
              tagTitleCount = tagTitleCount + title.length;
              if(tagTitleCount <= TAG_TITLE_COUNT) {
                tagTitleArr.push(title);
              }
          });
          if(tagTitleCount >= TAG_TITLE_COUNT) {
            tagDetail.title = tagTitleArr.join(' ')+' ...';
          } else {
            tagDetail.title = tagTitleArr.join(' ');
          }
        })
        dispatch({
            type    : actionType,
            payload : response.data
        })
      }) .catch(function (error) {
        callback(error.response);
      });
    }
}

export function updateTagId(tagId) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_TAG_ID,
      payload: tagId
    })
  }
}



// WEBPACK FOOTER //
// ./actions/DashboardAction.js